import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { addPaymentAccount, updatePayment } from "../services/paymentApi";
import { useQuery, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import FormField from "../../../common/Form/FormField";
import { BankOutlined } from "@ant-design/icons";

const AddEditDevForm = ({ modal, setModal, toggle, selectedPayment, currentuser }) => {
  
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false);

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Oups!!! Veuillez renseigner le nom"),
    country: Yup.string().required("Veuillez renseigner le pays"),
    description: Yup.string().required("Merci de renseigner la description"),
  });

  const initialValues = selectedPayment ? {
    name: selectedPayment.name,
    country: selectedPayment.country,
    description: selectedPayment.description,
  } : {
    name: "",
    description: ""
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setisLoadingSubmit(true);
      try {
        
        if (selectedPayment) {
          await updatePayment(selectedPayment?.id, {...values});
          toast.success("Le payement a été modifié avec succès 🎉");
        } else {
          await addPaymentAccount({...values});
          toast.success("Le payement a été créé avec succès 🎉");
        }
        await queryClient.invalidateQueries("payments");
        toggle();
        formik.resetForm();
      } catch (error) {
        console.error("Erreur :", error?.message || error);
        toast.error("😌 Erreur lors de l'ajout ou modification du payement :", error?.message || error);
      } finally {
        setisLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedPayment]);

  const modalTitle = selectedPayment ? "Édition" : `Ajout`;

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{maxWidth:"700px"}}
    >
      <ModalHeader className="active-tab p-3" toggle={toggle}>
        {modalTitle} d'une méthode de paiement  <BankOutlined />
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
            <Row>
              <FormField label="Nom" name="name" formik={formik} colSize={6} placeholder="Le nom de la méthode de paiement" />
              <FormField label="Pays" name="country" formik={formik} colSize={6} placeholder="Le pays qu'il est rattaché" />
              <FormField label="Description" name="description" formik={formik} colSize={12} placeholder="Entrez la description" isTextarea={true} />
            </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          <Button type="submit" className="active-tab" disabled={isLoadingSubmit}>
            {isLoadingSubmit ? <Spin size="small" text="En cours" /> : (selectedPayment ? "Modifier" : "Ajouter")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditDevForm;
